<div class="Popup" [formGroup]="DialogForm" id="DialogForm">

  <div class="popup-inner-space">
      <div class="betweenheader" style="color: #000;">Are you sure you want to delete this {{entityName}}?</div>
    <div class="text-right flow-right">
      <img src="assets/images/close_icon.svg" id="close-icon" alt="..." class="img-fluid close-space23 closeicon2 cursor-pointer" (click)="Close()">
    </div>
  </div>
  <div class="popup-inner-space">
    <div mat-dialog-actions class="Cancelactionsection">
        <button class="btncommon" id="btn-yes" (click)="OnYes()">Yes</button>
        <button class="btncommon-grey btn-border margin-left-10" id="btn-no" (click)="OnNo()">No</button>
    </div>
  </div>
</div>
